<div class="block--content block" id="main-content">
    <div class="block--wrap block">
        <rwidget-alert></rwidget-alert>

        <div class="ticket" *ngIf="(loaded$ | async) && (companiesOnly$ | async)?.length > 0">
            <div class="companies-area">
                <div class="intro-text">
                    <p class="title">
                        {{ 'ACCOUNT_COMPANIES_PAGE_MAIN_TITLE' | translate }}
                    </p>
                    <p>{{ 'ACCOUNT_COMPANIES_PAGE_DESCRIPTION' | translate }}</p>
                    <div class="add-corporate-company">
                        <div class="add-corporate-company__title">
                            {{ 'ACCOUNT_COMPANIES_PAGE_SUB_TITLE' | translate }}
                        </div>
                        <div class="add-corporate-company__selection">
                            <a
                                class="link link--action"
                                [routerLink]="'/account/add-company' | localize"
                                routerLinkActive="active">
                                {{ 'ACCOUNT_COMPANIES_PAGE_LINK_ADD_NEW_COMPANY' | translate }}
                            </a>
                        </div>
                    </div>
                </div>
                <div class="block-items-3">
                    <ridango-selectable-checkable-item
                        *ngFor="let company of companiesOnly$ | async"
                        [item]="company"
                        [selected]="company.id === (selectedCompany$ | async)?.id"
                        [itemImage]="true"
                        [customImageUrl]="'assets/company/company-icon.svg'"
                        (onItemSelected)="select($event)">
                    </ridango-selectable-checkable-item>
                </div>
            </div>
        </div>

        <div
            class="ticket"
            *ngIf="
                (loaded$ | async) &&
                env.SHOW_DEPARTMENTS &&
                ((selectedCompany$ | async) || (filteredDepartments$ | async)?.length > 0)
            ">
            <div class="companies-area">
                <div class="intro-text">
                    <div class="add-corporate-company">
                        <div class="add-corporate-company__title">
                            {{ 'ACCOUNT_DEPARTMENTS_PAGE_SUB_TITLE' | translate }}
                        </div>
                        <div class="add-corporate-company__selection">
                            <ng-container *ngIf="selectedCompany$ | async as selectedCompany">
                                <a
                                    class="link link--action"
                                    *ngIf="selectedCompany && !selectedCompany.parentCompany.id"
                                    [routerLink]="'/account/add-department' | localize"
                                    routerLinkActive="active">
                                    {{ 'ACCOUNT_DEPARTMENTS_PAGE_LINK_ADD_NEW_DEPARTMENT' | translate }}
                                </a>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="block-items-3">
                    <ng-container *ngIf="filteredDepartments$ | async as filteredDepartments">
                        <ng-container *ngIf="filteredDepartments.length > 0; else noDepartments">
                            <ridango-selectable-checkable-item
                                *ngFor="let department of filteredDepartments"
                                [item]="department"
                                [selected]="department.id === (selectedCompany$ | async)?.id"
                                [itemImage]="true"
                                [customImageUrl]="'assets/company/department-icon.svg'"
                                (onItemSelected)="select($event)">
                            </ridango-selectable-checkable-item>
                        </ng-container>
                        <ng-template #noDepartments>
                            <p>{{ 'COMPANY_NO_DEPARTMENTS_MESSAGE' | translate }}</p>
                        </ng-template>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="ticket" *ngIf="(loaded$ | async) && (companies$ | async).length === 0">
            <p class="page-title">
                {{ 'WELCOME_TITLE_COMPANY' | translate }}
            </p>
            <div class="not-company-found">
                <div class="block-half-width">
                    <div class="block-full-width no-empty-state-block">
                        <div class="block-full-width-area">
                            <div class="existing-company">
                                <img
                                    class="mb-3 h-20 dark:filter-yellow"
                                    alt=""
                                    src="assets/company/check-company-icon.svg" />
                                <p class="existing-company__title">
                                    {{ 'JOIN_COMPANY' | translate }}
                                </p>
                                <p>{{ 'CONTACT_COMPANY_TO_GET_ACCESS' | translate }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block-half-width last">
                    <div class="block-full-width no-empty-state-block">
                        <div class="block-full-width-area">
                            <div class="create-company">
                                <img
                                    class="mb-3 h-20 dark:filter-yellow"
                                    alt=""
                                    src="assets/company/add-company-icon.svg" />
                                <p class="create-company__title">
                                    {{ 'CREATE_NEW_COMPANY' | translate }}
                                </p>
                                <button
                                    class="btn btn--primary"
                                    [routerLink]="'/account/add-company' | localize"
                                    routerLinkActive="router-link-active">
                                    {{ 'CREATE_COMPANY_ACCOUNT' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
